// extracted by mini-css-extract-plugin
export default {"payment-section":"metodopago_payment-section__6NXPn","step":"metodopago_step__N96fN","divider":"metodopago_divider__OiAuW","bankDetails":"metodopago_bankDetails__Jrklz"};